import { ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import { ToggleButtonStatusSubmenu } from "../../../../components";
import {
  ACTION_ITEM_STATUSES,
  ActionItemStatus,
  ActiveActionItemStatuses,
  ClosedActionItemStatuses,
  UserStrategyFilterByOption,
} from "../../../../constants";

interface Props {
  filterByOption: UserStrategyFilterByOption;
  filterByStatusOptions: ActionItemStatus[] | null;
  onChange: (filterByOption: UserStrategyFilterByOption, filterByStatusOptions: ActionItemStatus[] | null) => void;
}

const UserStrategyFilterToggleButton = (props: Props) => {
  function handleFilterByChanged(value: UserStrategyFilterByOption) {
    // The status filter option should only be set after a status option is selected from the submenu
    if (value != null && value !== UserStrategyFilterByOption.Status) {
      props.onChange(value, null);
    }
  }

  function handleFilterByStatusChanged(values: ActionItemStatus[]) {
    if (values.length === 0) {
      props.onChange(UserStrategyFilterByOption.All, null);
      return;
    }

    props.onChange(UserStrategyFilterByOption.Status, values);
  }

  return (
    <>
      <ToggleButtonGroup
        value={props.filterByOption}
        exclusive
        orientation="vertical"
        variant="menu"
        onChange={(_, value) => handleFilterByChanged(value)}
        sx={{ minWidth: "100%" }}
      >
        <ToggleButton value={UserStrategyFilterByOption.All}>
          <Typography>All</Typography>
        </ToggleButton>

        <ToggleButtonStatusSubmenu
          value={UserStrategyFilterByOption.Status}
          statuses={ACTION_ITEM_STATUSES}
          selectedStatusIds={props.filterByStatusOptions?.map((x) => Number(x)) ?? []}
          activeStatusFilter={(x) => ActiveActionItemStatuses.includes(x.id)}
          closedStatusFilter={(x) => ClosedActionItemStatuses.includes(x.id)}
          onStatusSelected={(x) => handleFilterByStatusChanged(x)}
          menuProps={{
            anchorOrigin: {
              horizontal: "left",
              vertical: "top",
            },
            transformOrigin: {
              horizontal: "right",
              vertical: "top",
            },
          }}
        />
      </ToggleButtonGroup>
    </>
  );
};

export { UserStrategyFilterToggleButton };
